import React from "react";
import { Item } from "@exiftrator/shared/components/ui";
import { Thumbnail } from "../Thumbnail";
import { formatDisplayDateTime } from "../../utils/dateUtils";
import { getDateStatus } from "./fileListProjectionUtils";
import { cn } from "../utils/cn";
import { WORKSPACE_SPACING } from "../Workspace/workspaceSpacing";

function FileQueueItem({
  row,
  isSelected,
  onClick,
  onDragStart,
  compact = false,
}) {
  const { file, index } = row;
  const dateStatus = getDateStatus(file);
  const displayDate =
    dateStatus === "with-date"
      ? formatDisplayDateTime(file.modifiedExifData?.dateTaken, "No date", {
          includeSeconds: true,
          yearFormat: "2-digit",
        })
      : dateStatus === "invalid-date"
        ? "Invalid date"
        : "No date";

  return (
    <Item
      data-file-index={index}
      draggable={true}
      onDragStart={(event) => onDragStart(event, index)}
      onClick={(event) => onClick(index, event)}
      selected={isSelected}
      className={cn(
        compact
          ? "gap-2 p-2"
          : `${WORKSPACE_SPACING.listItemGap} ${WORKSPACE_SPACING.listItemPadding}`,
      )}
      title={file.name}
    >
      <div className="relative">
        <Thumbnail
          src={file.thumbnailUrl}
          alt={file.name}
          size={compact ? "sm" : "preview"}
          selected={isSelected}
        />
        {file.hasChanges && (
          <span
            className="absolute right-0 top-0 size-2 rounded-full border border-bg-secondary bg-accent-primary shadow-xs"
            title="Edited (unsaved changes)"
            aria-label="Edited (unsaved changes)"
          />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="truncate text-xs font-semibold text-foreground" title={file.name}>
          {file.name}
        </div>
        {!compact && (
          <div className="mt-0.5 truncate text-xs font-mono text-foreground/70" title={displayDate}>
            {displayDate}
          </div>
        )}
      </div>
    </Item>
  );
}

export default React.memo(FileQueueItem);
